import { type Dispatch, useContext } from "react";
import {
  CartActions,
  CartContext,
  CartContextDispatch,
  CartState,
} from "src/contexts/cart.context";

export function useCartContext(): CartState {
  const cartContext = useContext(CartContext);

  if (!cartContext) {
    throw new Error(
      "Please make sure you use useCartContext inside CartContextProvider."
    );
  }

  return cartContext;
}

export function useCartContextDispatch(): Dispatch<CartActions> {
  const cartContextDispatch = useContext(CartContextDispatch);

  if (!cartContextDispatch) {
    throw new Error(
      "Please make sure you use useCartContextDispatch inside CartContextProvider."
    );
  }

  return cartContextDispatch;
}
